{
    "OninboundalertingPara": "Sie können Alarme aktivieren, wenn eingehende Anrufe zu lange signalisiert werden.",
    "OntalktimePara": "Sie können auch Alarme aktivieren, wenn ein Anruf eine Sprechzeitschwelle erreicht.",
    "OninboundalertingLabel": "Bei eingehender Benachrichtigung über:",
    "OntalktimeLabel": "Bei Sprechzeit vorbei:",
    "OninboundalertingEnabledHiddenlabel": "Ist die Einstellung „Eingehende Benachrichtigung bei Überschreitung“ aktiviert?",
    "OntalktimeEnabledHiddenlabel": "Ist die Einstellung „Gesprächszeit über“ aktiviert?",
    "OninboundalertingPlaceholder": "15s",
    "OntalktimePlaceholder": "5m 0s",
    "CallStateThresholds_SectionHeader": "Rufzustandsschwellenwerte",
    "NAME": "CallStateThresholds"
}